export default {
  en: "English"
}
